module.exports = __webpack_public_path__ + "img/collection.c7a2092a.png";